/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * karevi
 * CategoryForm.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {TextField} from "../../../tools/model/form/TextField";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {VideoMetaDataDTO} from "../../dto/video/VideoMetaDataDTO";
import {CheckboxField} from "../../../tools/model/form/CheckboxField";
import {LongTextField} from "../../../tools/model/form/LongTextField";

export default class VideoMetaDataForm extends AbstractForm<VideoMetaDataDTO> {

    constructor(dto?: VideoMetaDataDTO) {
        super();

        this.fields.set(VideoMetaDataDTO.TITLE, new TextField(
            VideoMetaDataDTO.TITLE,
            (t: Translation) => t.title,
            value => value.toString().length > 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        this.fields.set(VideoMetaDataDTO.SUBTITLE, new TextField(
            VideoMetaDataDTO.SUBTITLE,
            (t: Translation) => t.subtitle,
            value => value.toString().length > 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        this.fields.set(VideoMetaDataDTO.DESCRIPTION, new LongTextField(
            VideoMetaDataDTO.DESCRIPTION,
            (t: Translation) => t.description,
            value => value.toString().length > 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        this.fields.set(VideoMetaDataDTO.LENGTH_S, new TextField(
            VideoMetaDataDTO.LENGTH_S,
            (t: Translation) => t.duration,
            value => value.toString().length > 0,
            Type.NUMBER,
            true,
            "",
            ""
        ));

        this.fields.set(VideoMetaDataDTO.PUBLISHED, new CheckboxField(
            VideoMetaDataDTO.PUBLISHED,
            (t: Translation) => t.published,
            () => true,
            Type.CHECKBOX,
            true,
            false,
            false
        ));

        if (dto) super.load(dto);
    }
}
